import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, PieChart, Pie, Cell, LineChart, Line, ResponsiveContainer } from 'recharts';
import { DownloadIcon, FilterIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { reportDistrictData, reportMutationData, reportTaxData } from '../data/sampleData';
const COLORS = ['#006A4E', '#C9A84C', '#3B82F6', '#EF4444', '#8B5CF6'];
export function ReportsPage() {
  const {
    language,
    t
  } = useLanguage();
  return <div className="space-y-6" data-id="element-1429">
      <div className="flex justify-between items-center" data-id="element-1430">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-1431">{t('navReports')}</h1>
        <div className="flex space-x-2" data-id="element-1432">
          <button className="px-3 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 transition-colors text-sm flex items-center" data-id="element-1433">
            <FilterIcon className="w-4 h-4 mr-2" data-id="element-1434" /> Filter
          </button>
          <button className="px-3 py-2 bg-[#006A4E] text-white rounded-lg font-medium hover:bg-[#004D3A] transition-colors text-sm flex items-center shadow-sm" data-id="element-1435">
            <DownloadIcon className="w-4 h-4 mr-2" data-id="element-1436" /> Export
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-1437">
        {/* District Distribution */}
        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200" data-id="element-1438">
          <h2 className="text-lg font-bold text-gray-900 mb-6" data-id="element-1439">
            District-wise Plot Distribution
          </h2>
          <div className="h-64" data-id="element-1440">
            <ResponsiveContainer width="100%" height="100%" data-id="element-1441">
              <BarChart data={reportDistrictData} data-id="element-1442">
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E5E7EB" data-id="element-1443" />
                <XAxis dataKey={language === 'bn' ? 'nameBn' : 'name'} axisLine={false} tickLine={false} data-id="element-1444" />
                <YAxis axisLine={false} tickLine={false} data-id="element-1445" />
                <Tooltip cursor={{
                fill: '#F3F4F6'
              }} contentStyle={{
                borderRadius: '8px',
                border: 'none',
                boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)'
              }} data-id="element-1446" />
                <Bar dataKey="plots" fill="#006A4E" radius={[4, 4, 0, 0]} data-id="element-1447" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Mutation Status */}
        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200" data-id="element-1448">
          <h2 className="text-lg font-bold text-gray-900 mb-6" data-id="element-1449">
            Mutation Status Overview
          </h2>
          <div className="h-64" data-id="element-1450">
            <ResponsiveContainer width="100%" height="100%" data-id="element-1451">
              <PieChart data-id="element-1452">
                <Pie data={reportMutationData} cx="50%" cy="50%" innerRadius={60} outerRadius={80} paddingAngle={5} dataKey="value" nameKey={language === 'bn' ? 'nameBn' : 'name'} data-id="element-1453">
                  {reportMutationData.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} data-id="element-1454" />)}
                </Pie>
                <Tooltip contentStyle={{
                borderRadius: '8px',
                border: 'none',
                boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)'
              }} data-id="element-1455" />
                <Legend verticalAlign="bottom" height={36} data-id="element-1456" />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Tax Collection Trend */}
        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200 lg:col-span-2" data-id="element-1457">
          <h2 className="text-lg font-bold text-gray-900 mb-6" data-id="element-1458">
            Tax Collection Trend (2026)
          </h2>
          <div className="h-72" data-id="element-1459">
            <ResponsiveContainer width="100%" height="100%" data-id="element-1460">
              <LineChart data={reportTaxData} data-id="element-1461">
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E5E7EB" data-id="element-1462" />
                <XAxis dataKey="month" axisLine={false} tickLine={false} data-id="element-1463" />
                <YAxis axisLine={false} tickLine={false} data-id="element-1464" />
                <Tooltip contentStyle={{
                borderRadius: '8px',
                border: 'none',
                boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)'
              }} data-id="element-1465" />
                <Legend data-id="element-1466" />
                <Line type="monotone" dataKey="paid" name="Paid Tax" stroke="#006A4E" strokeWidth={3} dot={{
                r: 4
              }} activeDot={{
                r: 6
              }} data-id="element-1467" />
                <Line type="monotone" dataKey="due" name="Due Tax" stroke="#EF4444" strokeWidth={3} dot={{
                r: 4
              }} activeDot={{
                r: 6
              }} data-id="element-1468" />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>;
}